import { IconProps } from '../Icons.type'

export function ChatIcon(props: IconProps) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      {...props}
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.83333 1.66667C2.52391 1.66667 2.22717 1.78958 2.00838 2.00838C1.78958 2.22717 1.66667 2.52391 1.66667 2.83333V12.8333C1.66667 13.1428 1.78958 13.4395 2.00838 13.6583C2.22717 13.8771 2.52391 14 2.83333 14H4.83333C5.29357 14 5.66667 14.3731 5.66667 14.8333V17.0995L9.31275 14.1826C9.46052 14.0644 9.64411 14 9.83333 14H16.8333C17.1428 14 17.4395 13.8771 17.6583 13.6583C17.8771 13.4395 18 13.1428 18 12.8333V2.83333C18 2.52391 17.8771 2.22717 17.6583 2.00838C17.4395 1.78958 17.1428 1.66667 16.8333 1.66667H2.83333ZM0.829864 0.829864C1.36122 0.298511 2.08189 0 2.83333 0H16.8333C17.5848 0 18.3055 0.298511 18.8368 0.829864C19.3682 1.36122 19.6667 2.08189 19.6667 2.83333V12.8333C19.6667 13.5848 19.3682 14.3055 18.8368 14.8368C18.3055 15.3682 17.5848 15.6667 16.8333 15.6667H10.1257L5.35391 19.4841C5.10377 19.6842 4.76106 19.7232 4.47234 19.5844C4.18362 19.4457 4 19.1537 4 18.8333V15.6667H2.83333C2.08189 15.6667 1.36122 15.3682 0.829864 14.8368C0.298511 14.3055 0 13.5848 0 12.8333V2.83333C0 2.08189 0.298511 1.36122 0.829864 0.829864Z"
        fill="currentColor"
      />
    </svg>
  )
}
